import React from 'react';
import { Badge } from '../common/Badge';

export const NetworkBadges = ({ network }) => (
  <div className="d-flex flex-wrap gap-1">
    {network.isHot && <Badge type="hot">Hot</Badge>}
    {network.isFavorite && <Badge type="favorite">Favorite</Badge>}
    {network.isVerified && <Badge type="verified">Verified</Badge>}
    {network.isPublic && <Badge type="public">Public</Badge>}
    {network.isSuspended && <Badge type="suspended">Suspended</Badge>}
    {network.userModerationEnabled && <Badge type="moderation">Moderation</Badge>}
  </div>
);
